
import React from "react";
import { Control, Controller } from "react-hook-form";
import { SiteVisitPropertyData, SiteVisitPropertyUpdateData } from "../../core/api/models/sitevisit";
import { AppSettings, Dict, User } from "../../core";
import RemoteDataMultiSelectDropDown from "../../components/dropdown/RemoteDataMultiSelectDropDown";
import { DateInput } from "../../components/form-group";
import TimeInput from "../../components/form-group/time-input";
import ErrorMessage from "../../components/text/ErrorMessage";
import { UserImage } from "../../components/user-image";
import api from "../../api";

interface ScheduleSiteVisitSelectedPropertyFormProps {
    appSettings: {
        reload: () => void;
        data?: AppSettings;
        loaded?: boolean;
        loading?: boolean;
        error?: any;
    }
    control: Control<Dict<any>>;
    currentSelectedPropertyDetail: SiteVisitPropertyUpdateData;
    isReload: boolean;
    prop: string;
    propertyData: { [key: string]: SiteVisitPropertyData; } | undefined;
    setCurrentSelectedPropertyDetail: React.Dispatch<React.SetStateAction<SiteVisitPropertyUpdateData>>;
    setIsReload: React.Dispatch<React.SetStateAction<boolean>>;
    setOpenLandLordModal: React.Dispatch<React.SetStateAction<boolean>>;
    setPropertyData: React.Dispatch<React.SetStateAction<{ [key: string]: SiteVisitPropertyData; } | undefined>>;
    setPropertyDetail: (update: { [key: string]: string | Date | User[]; }) => void;
    setValidationError: React.Dispatch<React.SetStateAction<string>>;
    validatePropertyData: (property: SiteVisitPropertyUpdateData) => boolean;
    validationError: string;
    watch: any
}

export function ScheduleSiteVisitSelectedPropertyForm({ appSettings,
    control,
    currentSelectedPropertyDetail,
    isReload,
    prop,
    propertyData,
    setCurrentSelectedPropertyDetail,
    setIsReload,
    setOpenLandLordModal,
    setPropertyData,
    setPropertyDetail,
    setValidationError,
    validatePropertyData,
    validationError,
    watch }: ScheduleSiteVisitSelectedPropertyFormProps) {

          const loadAgents = async () => {
            const response = await api.customer.searchStaff({
              hideBlocked: true,
            });
        
            return response;
          };

          const loadLandLords = async () => {
            const response = await api.sitevisit.getLandLords(
              currentSelectedPropertyDetail.currentSelectedPropertyId
            );
            // return response;
            return [...response, { contactName: "AddLandLord" }];
          };
        
    return (
        <div className="row py-3">
            <div className="col-md-8 col-12 mb-2">
                <label
                    className="font-sm font-weight-semibold mb-2 text-uppercase"
                    htmlFor="selectedparticipants"
                >
                    Select Cityinfo Participants
                    <span className="text-danger">
                        *
                    </span>
                </label>
                <Controller
                    control={control}
                    name="agents"
                    defaultValue={
                        currentSelectedPropertyDetail?.agents
                    }
                    render={({
                        onChange,
                        value,
                        name,
                    }) => (
                        <RemoteDataMultiSelectDropDown
                            loadData={loadAgents}
                            textField="name"
                            value={value}
                            defaultValue={value}
                            valueField="_id"
                            onChange={(val) => {
                                onChange(val);
                                setPropertyDetail({
                                    agents: watch("agents"),
                                });
                            }}
                            placeholder="Select Cityinfo Participants"
                            itemComponent={({ item }) => (
                                <UserImage
                                    user={item}
                                ></UserImage>
                            )}
                            tagComponent={({ item }) => (
                                <UserImage
                                    user={item}
                                ></UserImage>
                            )}
                        ></RemoteDataMultiSelectDropDown>
                    )}
                />{" "}
            </div>
            <div className="col-md-8 col-12 mb-2">
                <label
                    className="font-sm font-weight-semibold mb-2 text-uppercase"
                    htmlFor="selectedparticipants"
                >
                    Select Landlord User
                </label>
                <Controller
                    control={control}
                    name="landLords"
                    defaultValue={
                        currentSelectedPropertyDetail?.landlord
                    }
                    render={({
                        onChange,
                        value,
                        name,
                    }) => (
                        <RemoteDataMultiSelectDropDown
                            loadData={loadLandLords}
                            isReload={isReload}
                            textField="contactName"
                            value={value}
                            defaultValue={value}
                            valueField="_id"
                            onChange={(val) => {
                                onChange(
                                    val.filter(
                                        (item: {
                                            contactName: string;
                                        }) =>
                                            item?.contactName !==
                                            "AddLandLord"
                                    )
                                );
                                setPropertyDetail({
                                    landlord: watch(
                                        "landLords"
                                    ),
                                });
                            }}
                            placeholder="Select Landlords"
                            itemComponent={({ item }) => (
                                <React.Fragment>
                                    {item.contactName ===
                                        "AddLandLord" ? (
                                        <>
                                            <button
                                                type="button"
                                                className="btn btn-link font-md p-0 font-weight-semibold"
                                                onClick={() => {
                                                    setOpenLandLordModal(
                                                        true
                                                    );
                                                    setIsReload(false);
                                                }}
                                            >
                                                + Add New User
                                            </button>
                                        </>
                                    ) : (
                                        <UserImage
                                            user={{
                                                name:
                                                    item?.contactName,
                                            }}
                                        ></UserImage>
                                    )}
                                </React.Fragment>
                            )}
                            tagComponent={({ item }) => (
                                <UserImage
                                    user={{
                                        name: item?.contactName,
                                    }}
                                ></UserImage>
                            )}
                        ></RemoteDataMultiSelectDropDown>
                    )}
                />{" "}
            </div>
            <div className="w-100"></div>
            <div className="col-8">
                <label
                    className="font-sm font-weight-semibold mb-2 text-uppercase"
                    htmlFor="selectedparticipants"
                >
                    Date
                    <span className="text-danger">
                        *
                    </span>
                </label>
                <div className="row gutter-8 align-items-center">
                    <div className="col-5">
                        <DateInput
                            default={
                                currentSelectedPropertyDetail?.date
                            }
                            placeholder={"dd MMM yyyy"}
                            onChange={(v) => {
                                if (validationError) {
                                    setValidationError("");
                                }
                                setPropertyDetail({
                                    date: v,
                                });
                            }}
                            dateFormat="dd MMM yyyy"
                            minDate={new Date()}
                        />
                    </div>
                    <div className="col-3">
                        <TimeInput
                            default={
                                currentSelectedPropertyDetail?.start ||
                                ""
                            }
                            placeholder={"HH:mm"}
                            onChange={(v) => {
                                if (validationError) {
                                    setValidationError("");
                                }
                                setPropertyDetail({
                                    start: v,
                                });
                            }}
                            range="8-8"
                            startTime={
                                appSettings?.data?.application
                                    ?.appointmentTime?.start ??
                                "9:00 AM"
                            }
                            endTime={
                                appSettings?.data?.application
                                    ?.appointmentTime?.end ??
                                "9:00 PM"
                            }
                            avoidToday={true}
                        />
                    </div>
                    <div className="px-0 font-weight-bold text-gray-400 font-xl">
                        -
                    </div>
                    <div className="col-3">
                        <TimeInput
                            default={
                                currentSelectedPropertyDetail?.end ||
                                ""
                            }
                            placeholder={"HH:mm"}
                            onChange={(v) => {
                                if (validationError) {
                                    setValidationError("");
                                }
                                setPropertyDetail({
                                    end: v,
                                });
                            }}
                            range="8-8"
                            startTime={
                                currentSelectedPropertyDetail?.start !==
                                    ""
                                    ? currentSelectedPropertyDetail?.start
                                    : "9:00 AM"
                            }
                            endTime={
                                appSettings?.data?.application
                                    ?.appointmentTime?.end ??
                                "9:00 PM"
                            }
                            avoidToday={true}
                            secondTime={true}
                        />
                    </div>
                </div>
            </div>
            <div className="col-12 pt-1 mb-1">
                {validationError && (
                    <ErrorMessage>
                        {" "}
                        {validationError}
                    </ErrorMessage>
                )}
            </div>
            <div className="col-12 pt-4 mb-3">
                <span className="bg-white d-inline-block mr-3">
                    <button
                        type="button"
                        className="btn btn-outline-secondary font-normal py-2 font-weight-bold px-4 rounded"
                        onClick={() =>
                            setPropertyDetail({
                                landlord: [],
                                date: new Date(),
                                start: "",
                                end: "",
                                currentSelectedPropertyId: "",
                            })
                        }
                    >
                        <span className="px-2">
                            Cancel
                        </span>
                    </button>
                </span>
                <button
                    type="button"
                    className="btn btn-primary font-normal py-2 font-weight-bold px-5 rounded"
                    disabled={
                        currentSelectedPropertyDetail?.date &&
                            currentSelectedPropertyDetail?.start &&
                            currentSelectedPropertyDetail?.end &&
                            currentSelectedPropertyDetail
                                ?.agents?.length
                            ?
                            !validatePropertyData({
                                date: currentSelectedPropertyDetail?.date!,
                                start: currentSelectedPropertyDetail?.start!,
                                end: currentSelectedPropertyDetail?.end!,
                                landlord:
                                    currentSelectedPropertyDetail?.landlord! ||
                                    [],
                                currentSelectedPropertyId: prop,
                            })
                            : true
                    }
                    onClick={() => {
                        setPropertyData({
                            ...(propertyData || {}),
                            [prop]: {
                                date: currentSelectedPropertyDetail?.date!,
                                start: currentSelectedPropertyDetail?.start!,
                                end: currentSelectedPropertyDetail?.end!,
                                landlord: currentSelectedPropertyDetail?.landlord!,
                                agents: currentSelectedPropertyDetail?.agents!,
                            },
                        });
                        setCurrentSelectedPropertyDetail({
                            landlord: [],
                            date: new Date(),
                            start: "",
                            end: "",
                            currentSelectedPropertyId: "",
                            agents: [],
                        });
                    }}
                >
                    Save
                </button>
            </div>
        </div>
    );
}
